import React from 'react';
import { ShoppingCart } from 'lucide-react';

/**
 * Order form component for completing book purchases
 */
const OrderForm = ({ 
  selectedBook, 
  uploadedImage, 
  quantity, 
  setQuantity, 
  userInfo, 
  setUserInfo, 
  handleOrderSubmit 
}) => (
  <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl p-8 mb-8">
    <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
      Complete Your Order
    </h2>
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Order Summary */}
      <div className="bg-gradient-to-br from-purple-50 to-blue-50 p-6 rounded-2xl">
        <h3 className="text-xl font-semibold mb-4">📦 Order Summary</h3>
        
        {selectedBook && (
          <div className="flex space-x-4 mb-4">
            <img src={selectedBook.image} alt={selectedBook.title} className="w-20 h-24 object-cover rounded-lg shadow-md" />
            <div className="flex-1">
              <h4 className="font-semibold">{selectedBook.title}</h4>
              <p className="text-gray-600">{selectedBook.author}</p>
              <p className="text-green-600 font-bold">${selectedBook.price}</p>
            </div>
          </div>
        )}
        
        {uploadedImage && !selectedBook && (
          <div className="flex space-x-4 mb-4">
            <img src={uploadedImage} alt="Uploaded book" className="w-20 h-24 object-cover rounded-lg shadow-md" />
            <div className="flex-1">
              <h4 className="font-semibold">Custom Book Upload</h4>
              <p className="text-gray-600">Image provided</p>
            </div>
          </div>
        )}
        
        <div className="space-y-2">
          <div className="flex justify-between">
            <span>Quantity:</span>
            <span className="font-semibold">{quantity}</span>
          </div>
          {selectedBook && (
            <div className="flex justify-between text-lg font-bold text-green-600 border-t pt-2">
              <span>Total:</span>
              <span>${(selectedBook.price * quantity).toFixed(2)}</span>
            </div>
          )}
        </div>
      </div>

      {/* User Form */}
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Quantity</label>
          <input
            type="number"
            min="1"
            value={quantity}
            onChange={(e) => setQuantity(parseInt(e.target.value))}
            className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-200 focus:border-purple-400 transition-all"
          />
        </div>
        
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Your Name *</label>
          <input
            type="text"
            placeholder="Enter your full name"
            value={userInfo.name}
            onChange={(e) => setUserInfo({...userInfo, name: e.target.value})}
            className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-200 focus:border-purple-400 transition-all"
          />
        </div>
        
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
          <input
            type="email"
            placeholder="your.email@example.com"
            value={userInfo.email}
            onChange={(e) => setUserInfo({...userInfo, email: e.target.value})}
            className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-200 focus:border-purple-400 transition-all"
          />
        </div>
        
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number (Optional)</label>
          <input
            type="tel"
            placeholder="+1 (555) 123-4567"
            value={userInfo.phone}
            onChange={(e) => setUserInfo({...userInfo, phone: e.target.value})}
            className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-200 focus:border-purple-400 transition-all"
          />
        </div>
        
        <button
          onClick={handleOrderSubmit}
          className="w-full bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-bold py-4 rounded-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-3"
        >
          <ShoppingCart className="w-6 h-6" />
          <span>Place Order Now</span>
        </button>
      </div>
    </div>
  </div>
);

export default OrderForm;
